/**
 * IMPORTS
 */
import {
  EXTENSOES_ANEXO_PERMITIDAS,
  MAXIMO_ANEXOS_CONVERSA,
  TAMANHO_MAXIMO_ANEXO_BYTES,
} from "@/interface/conversa-cliente";

function formatarTamanhoArquivo(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1).replace(".", ",")} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
}

function obterIniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  const primeira = partes[0]?.[0] ?? "?";
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] : "";
  return `${primeira}${ultima}`.toUpperCase();
}

/** Mesmas regras da API; devolve a primeira mensagem de erro ou null. */
function validarArquivosAnexo(atuais: File[], novos: File[]): string | null {
  if (atuais.length + novos.length > MAXIMO_ANEXOS_CONVERSA) {
    return `Envie no máximo ${MAXIMO_ANEXOS_CONVERSA} arquivos por mensagem.`;
  }

  for (const arquivo of novos) {
    const extensao = arquivo.name.includes(".")
      ? (arquivo.name.split(".").pop() ?? "").toLowerCase()
      : "";

    if (!(EXTENSOES_ANEXO_PERMITIDAS as readonly string[]).includes(extensao)) {
      return `Tipo de arquivo não permitido: ${arquivo.name}.`;
    }
    if (arquivo.size === 0) return `O arquivo ${arquivo.name} está vazio.`;
    if (arquivo.size > TAMANHO_MAXIMO_ANEXO_BYTES) {
      return `O arquivo ${arquivo.name} excede o limite de 10 MB.`;
    }
  }

  return null;
}

/**
 * EXPORTS
 */
export { formatarTamanhoArquivo, obterIniciais, validarArquivosAnexo };
